import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function MyReadings() {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/readings?days=30"); setItems(data.readings || []); })(); }, []);
  return (
    <div className="vb-fade-in" data-testid="my-readings">
      <h1 className="vb-heading text-3xl mb-1" style={{ color: "var(--vb-text-2)" }}>My recent readings</h1>
      <p className="opacity-70 mb-6">Last 30 days of your CCP submissions.</p>
      <div className="vb-card overflow-x-auto"><table className="vb-table">
        <thead><tr><th>When</th><th>CCP</th><th>Value</th><th>Status</th></tr></thead>
        <tbody>
          {items.length === 0 && <tr><td colSpan={4} style={{ textAlign: "center", padding: 28 }} className="opacity-60">No readings yet.</td></tr>}
          {items.map((r) => (
            <tr key={r.id}><td>{new Date(r.logged_at).toLocaleString()}</td><td>{r.ccp_name}</td>
              <td><strong>{r.value}{r.unit}</strong> <span className="opacity-60 text-xs">({r.min_value}–{r.max_value}{r.unit})</span></td>
              <td>{r.is_deviation ? <span className="vb-pill err">deviation</span> : <span className="vb-pill ok">ok</span>}</td></tr>
          ))}
        </tbody>
      </table></div>
    </div>
  );
}
